import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Category from '@mui/icons-material/Category';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Progress from '../components/Loader';
// import Box from '@mui/material/Box';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width:550,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal(props) {
  const [open, setOpen] = React.useState(props.value);
  const [category, setcategory] = React.useState("none");
  const [businesstype, setbusinesstype] = React.useState("none");
  const [gender, setgender] = React.useState("none");
  const [loading, setloading] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const [personName, setPersonName] = React.useState([]);

  const purchase = useSelector((state) => state.purchase).filter(bug=>bug.batch===props.chosen.batch)
console.log(purchase)

  const names = [

    "Crops",
    "Seeds",
    "Fertilizers",
    "Machinery",
    "Irrigation"

  ];


  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleClose=()=>{
  setOpen(false);
  props.setfalser()
  }




  return (
    <div>
     
     
 
<Dialog fullWidth minWidth="md" onClose={handleOpen} aria-labelledby="customized-dialog-title" open={open}>
<DialogTitle id="customized-dialog-title" onClose={handleClose} >
         View Purchases
     
       <IconButton onClick={handleClose} style={{float:"right"}}><CloseIcon/></IconButton>
      
   </DialogTitle>
   <Divider/>
 <DialogContent>
<Box>


<TableContainer >
          <Table sx={{ minWidth: 700 }} aria-label="spanning table">
         
            <TableHead>
    
              <TableRow>
                <TableCell align="left">Date</TableCell>
                <TableCell align="left">Quantity</TableCell>
                <TableCell align="left">Purchase Price</TableCell>
                <TableCell align="left">Balance</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {purchase.length!==0 && purchase.map((row) => (
                
                <TableRow key={row.date}>
                
                  <TableCell>{row.date}</TableCell>
                  <TableCell align="left">{row.qty+" "+row.expunit}</TableCell>
                  <TableCell align="left">GHC {row.amount}</TableCell>
                  <TableCell align="left">GHC {row.balance}</TableCell>
                </TableRow>
              ))}
              
            </TableBody>
          </Table>
        </TableContainer>
    

 </Box>
 </DialogContent>
 {/* <Divider/> */}
  
</Dialog>


</div>



  );
}
